import './RecentAwards.css'
import { useNavigate } from 'react-router-dom'

export default function RecentAwards({ awards, loading, error, onRetry }) {
  const navigate = useNavigate()

  const handleRetry = () => {
    if (typeof onRetry === 'function') {
      onRetry()
    }
  }

  // Icon mapping for fallback emojis
  const iconMap = {
    trophy: '🏆',
    medal: '🏅',
    bag_tag: '🏅',
    star: '⭐',
    calendar: '📅',
    'trending-up': '📈',
    heart: '❤️',
    zap: '⚡',
    refresh: '🔄',
    'check-circle': '✅',
  }

  // Get the fallback emoji icon for an award
  const getFallbackIcon = (award) => {
    return iconMap[award.icon_key] || iconMap[award.category] || '🎖️'
  }

  // Get icon display for an award - matches AwardCard logic
  const getIconDisplay = (award) => {
    // Priority: custom_icon_url > icon_key > category > default
    if (award.custom_icon_url) {
      return (
        <>
          <img
            src={award.custom_icon_url}
            alt={`${award.name} icon`}
            className="award-icon-image"
            onError={(e) => {
              // Fallback to emoji if image fails to load
              e.target.style.display = 'none'
              const fallback = e.target.nextSibling
              if (fallback) {
                fallback.style.display = 'inline-block'
              }
            }}
          />
          <span style={{ display: 'none', fontSize: '48px' }}>
            {getFallbackIcon(award)}
          </span>
        </>
      )
    }
    return getFallbackIcon(award)
  }

  if (loading) {
    return (
      <div
        className="recent-awards-loading"
        data-testid="recent-awards-loading"
      >
        <div className="loading-spinner"></div>
        <span>Loading awards...</span>
      </div>
    )
  }

  if (error) {
    return (
      <div className="recent-awards-error" data-testid="recent-awards-error">
        <p>Unable to load awards</p>
        <p className="error-subtitle">{error}</p>
        <button className="retry-button" onClick={handleRetry}>
          Try Again
        </button>
      </div>
    )
  }

  if (!awards || awards.length === 0) {
    return (
      <div className="recent-awards-empty" data-testid="recent-awards-empty">
        <p>
          No awards yet. Complete matches and achieve milestones to earn your
          first trophy!
        </p>
        <button
          className="browse-leagues-button"
          onClick={() => navigate('/register')}
        >
          Browse Leagues
        </button>
      </div>
    )
  }

  return (
    <div className="recent-awards" data-testid="recent-awards">
      <div className="recent-awards-list">
        {awards.slice(0, 3).map((award) => (
          <div key={award.id} className="award-item">
            <span
              className="award-icon"
              aria-label={award.category === 'trophy' ? 'Trophy' : 'Medal'}
              role="img"
            >
              {getIconDisplay(award)}
            </span>
            <div className="award-details">
              <div className="award-name">{award.name}</div>
              <div className="award-date">
                {award.earned_at
                  ? new Date(award.earned_at).toLocaleDateString('en-US')
                  : 'Unknown date'}
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        className="view-trophy-case-link"
        onClick={() => navigate('/trophy-case')}
      >
        View Trophy Case →
      </button>
    </div>
  )
}
